var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"dml-content-heading",attrs:{"data-t":"24.4"}},[_c('span',{staticClass:"dml-content-heading__text"},[_vm._v(_vm._s(_vm.props.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }